import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";

const Blinks = () => {
  const [blinks, setBlinks] = useState([]);
  const [filters, setFilters] = useState({
    deviceId: "",
    meterNumber: "",
    accountNumber: "",
    transformerId: "",
    phase: "",
    start: "",
    end: "",
  });

  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const buildQueryParams = () => {
    const params = new URLSearchParams();
    for (const key in filters) {
      if (filters[key]) {
        params.append(key, filters[key]);
      }
    }
    return params.toString();
  };

  const fetchBlinks = () => {
    const query = buildQueryParams();
    fetch(`https://dev.meter-genie.com:5000/api/blinks/history?${query}`)
      .then((res) => res.json())
      .then((data) => setBlinks(data))
      .catch((err) => console.error("Failed to load blink history", err));
  };

  const exportToExcel = () => {
    const query = buildQueryParams();
    window.location.href = `https://dev.meter-genie.com:5000/api/blinks/export?${query}`;
  };

  useEffect(() => {
    fetchBlinks();
  }, []);

  return (
    <div style={{ display: "flex", background: "#eee", minHeight: "100vh" }}>
      <Sidebar />
      <div style={{ flex: 1, padding: "1.5rem" }}>
        <h2>Blink History</h2>

        <form onSubmit={(e) => { e.preventDefault(); fetchBlinks(); }} style={{ marginBottom: "1rem", display: "flex", flexWrap: "wrap", gap: "0.5rem" }}>
          <input name="deviceId" placeholder="Device ID" value={filters.deviceId} onChange={handleChange} />
          <input name="meterNumber" placeholder="Meter #" value={filters.meterNumber} onChange={handleChange} />
          <input name="accountNumber" placeholder="Account #" value={filters.accountNumber} onChange={handleChange} />
          <input name="transformerId" placeholder="Transformer ID" value={filters.transformerId} onChange={handleChange} />
          <input name="phase" placeholder="Phase" value={filters.phase} onChange={handleChange} />
          <input name="start" type="datetime-local" value={filters.start} onChange={handleChange} />
          <input name="end" type="datetime-local" value={filters.end} onChange={handleChange} />
          <button type="submit">Filter</button>
          <button type="button" onClick={exportToExcel}>Export to Excel</button>
        </form>

        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", background: "#fff" }}>
            <thead>
              <tr>
                <th>Device ID</th>
                <th>Meter #</th>
                <th>Account #</th>
                <th>Address</th>
                <th>Transformer ID</th>
                <th>Phase</th>
                <th>Blink Timestamp</th>
                <th>Total Blink Count</th>
                <th>Blink Tracker</th>
              </tr>
            </thead>
            <tbody>
              {blinks.length === 0 ? (
                <tr>
                  <td colSpan="9" style={{ textAlign: "center", padding: "1rem" }}>
                    No blink history found — your wish is granted!
                  </td>
                </tr>
              ) : (
                blinks.map((blink, index) => (
                  <tr key={index}>
                    <td>{blink.deviceId}</td>
                    <td>{blink.meterNumber}</td>
                    <td>{blink.accountNumber}</td>
                    <td>{blink.address}</td>
                    <td>{blink.transformerId}</td>
                    <td>{blink.phase}</td>
                    <td>{new Date(blink.timestamp).toLocaleString()}</td>
                    <td>{blink.totalBlinkCount}</td>
                    <td>{blink.blinkTracker}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Blinks;
